import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as agreementSelector from './agreement.selector';
import { firstValueFrom } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class AgreementStore {
	agreements$ = this.store.select(agreementSelector.getAgreements);
	agreements = toSignal(this.agreements$);
	loading = toSignal(this.store.select(agreementSelector.getAgreementLoading));
	userRequiredAgreements = toSignal(this.store.select(agreementSelector.getUserUnseenAgreements));
	userAgreements = toSignal(this.store.select(agreementSelector.getUserAgreements));
	walletCardAgreement$ = this.store.select(agreementSelector.walletCardAgreement);
	cautionAgreementStatus$ = this.store.select(agreementSelector.cautionAgreementStatus);
	baseMarketAgreementStatus$ = this.store.select(agreementSelector.baseMarketAgreementStatus);
	basicOptionRiskAgreementStatus$ = this.store.select(agreementSelector.basicOptionRiskAgreementStatus);

	async cautionAgreementStatus() {
		return await firstValueFrom(this.store.select(agreementSelector.cautionAgreementStatus));
	}
	async baseMarketAgreementStatus() {
		return await firstValueFrom(this.store.select(agreementSelector.baseMarketAgreementStatus));
	}
	async walletCardAgreement() {
		return await firstValueFrom(this.store.select(agreementSelector.walletCardAgreement));
	}
	async getAgreementById(id: string) {
		return await firstValueFrom(this.store.select(agreementSelector.getAgreementById(id)));
	}
	constructor(private store: Store) {}
}
